<template>
  <div ref="wrapper">
    <model-select
      ref="modelSelect"
      :options="options"
      v-model="localValue"
      :placeholder="placeholder"
      :id="id"
      :is-error="isError"
      :is-disabled="isDisabled"
    >
      <template v-slot="{option}">
        <span v-html="option.richtext" v-if="option.richtext"></span>
        <span v-else-if="option.text">{{ option.text }}</span>
        <span v-else>{{ option.value }}</span>
      </template>
    </model-select>
  </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'ModelRichSelect',
  components: {
    ModelSelect
  },
  emits: ['update:modelValue'],
  props: {
    // Vue 3 v-model prop
    modelValue: {
      type: [String, Number, Object, Boolean],
      default: undefined
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    isError: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    customAttr: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      localValue: this.modelValue
    }
  },
  watch: {
    modelValue (nextValue) {
      if (nextValue !== this.localValue) {
        this.localValue = nextValue
      }
    },
    localValue (nextValue) {
      if (nextValue !== this.modelValue) {
        this.$emit('update:modelValue', nextValue)
      }
    }
  }
}
</script>
